export default __webpack_public_path__ + "a94c799de46f731e935ef253130fb0b5.svg";